// Write your code here
import {formatDistanceToNow} from 'date-fns'
import './index.css'

const CommentItem = props => {
  const {commentDetails, toggleIsLiked, deleteComment} = props
  const {id, name, comment, date, isLiked, initialClassName} = commentDetails

  const initialLetter = name ? name.slice(0, 1).toUpperCase() : ''
  const postedTime = formatDistanceToNow(date)

  const onClickLike = () => {
    toggleIsLiked(id)
  }

  const onClickDelete = () => {
    deleteComment(id)
  }

  const likeImgUrl = isLiked
    ? 'https://assets.ccbp.in/frontend/react-js/comments-app/liked-img.png'
    : 'https://assets.ccbp.in/frontend/react-js/comments-app/like-img.png'

  const likeTextClassName = isLiked ? 'like-text liked' : 'like-text'

  return (
    <li className="comment-item">
      <div className="comment-header">
        <div className={`avatar ${initialClassName}`}>
          <span className="avatar-text">{initialLetter}</span>
        </div>
        <div className="name-time-comment-container">
          <div className="name-time-container">
            <h1 className="username">{name}</h1>
            <p className="posted-time">{postedTime} ago</p>
          </div>
          <p className="comment-body">{comment}</p>
        </div>
      </div>
      <div className="comment-actions">
        <button type="button" className="like-btn" onClick={onClickLike}>
          <img src={likeImgUrl} alt="like" className="like-icon" />
          <span className={likeTextClassName}>Like</span>
        </button>
        <button
          type="button"
          className="delete-btn"
          onClick={onClickDelete}
          data-testid="delete"
        >
          <img
            src="https://assets.ccbp.in/frontend/react-js/comments-app/delete-img.png"
            alt="delete"
            className="delete-icon"
          />
        </button>
      </div>
      <hr className="item-divider" />
    </li>
  )
}

export default CommentItem
